import React from 'react';
import { 
  Activity, Heart, ShieldAlert, AlertTriangle, AlertCircle, ShieldCheck, Target, BarChart3, 
  Shield, Users, Download, Loader2, Sparkles, Brain, CheckCircle 
} from 'lucide-react';

import EditableAIBox from '../EditableAIBox';

// --- 1. BİREYSEL RAPOR ARAYÜZÜ ---
export const RosenbergReportUI = ({ data, meta }) => {
  const scores = data.scores || {};
  const d1Result = scores.D1 <= 1 ? { level: "YÜKSEK", color: "text-emerald-600", bg: "bg-emerald-500", desc: "Öğrencinin kendine verdiği değer yüksek, özgüveni sağlamdır." } : scores.D1 <= 4 ? { level: "ORTA", color: "text-amber-500", bg: "bg-amber-400", desc: "Öğrencinin özgüveninde dalgalanmalar mevcut." } : { level: "DÜŞÜK", color: "text-red-600", bg: "bg-red-500", desc: "Öğrenci kendini değersiz hissetmektedir." };
  
  const dimensions = [
    { id: "D2", title: "Kendilik Sürekliliği", score: scores.D2, max: 5, riskIfHigh: true, desc: scores.D2 <= 2 ? "Benlik algısı tutarlı ve dengeli." : "Kendisi hakkındaki fikirleri çok sık değişiyor." },
    { id: "D3", title: "İnsanlara Güven", score: scores.D3, max: 5, riskIfHigh: true, desc: scores.D3 <= 1 ? "İnsanlara güven duyuyor." : scores.D3 <= 3 ? "Temkinli yaklaşıyor." : "Ciddi güvensizlik yaşıyor." },
    { id: "D4", title: "Eleştiriye Duyarlılık", score: scores.D4, max: 3, riskIfHigh: true, desc: scores.D4 <= 1 ? "Eleştiriye karşı dirençli." : "Eleştirildiğinde çok inciniyor." },
    { id: "D5", title: "Depresif Duygulanım", score: scores.D5, max: 6, riskIfHigh: true, desc: scores.D5 === 0 ? "Depresif belirti yok." : scores.D5 <= 2 ? "Hafif karamsarlık." : "Yüksek depresif duygulanım!" },
    { id: "D6", title: "Hayalperestlik", score: scores.D6, max: 4, riskIfHigh: true, desc: scores.D6 <= 1 ? "Gerçekçi." : "Gerçeklikten kopup yoğun hayal kurma eğiliminde." },
    { id: "D7", title: "Psikosomatik Belirtiler", score: scores.D7, max: 10, riskIfHigh: true, desc: scores.D7 <= 2 ? "Fiziksel anksiyete düşük." : "Kaygı bedene vuruyor (Titreme vb.)." },
    { id: "D8", title: "İlişkilerde Tehdit", score: scores.D8, max: 3, riskIfHigh: true, desc: scores.D8 === 0 ? "İlişkilerde rahat." : "Sosyal ortamlarda kolayca tehdit altında hissediyor." },
    { id: "D9", title: "Tartışmaya Katılım", score: scores.D9, max: 2, riskIfHigh: false, desc: scores.D9 === 0 ? "Tartışmalardan kaçınıyor." : "Görüşlerini savunabiliyor." },
    { id: "D10", title: "Ana-Baba İlgisi", score: scores.D10, max: 7, riskIfHigh: true, desc: scores.D10 <= 2 ? "Ailesinin ilgisini yeterli buluyor." : "Ailesinden yeterli ilgiyi görmediğini düşünüyor." },
    { id: "D11", title: "Babayla İlişki", score: scores.D11, max: 6, riskIfHigh: false, desc: scores.D11 <= 2 ? "Babayla iletişim kopuk." : "Babasıyla ilişkisi yoğun." },
    { id: "D12", title: "Psişik İzolasyon", score: scores.D12, max: 2, riskIfHigh: true, desc: scores.D12 === 0 ? "Toplumla bağ kuruyor." : "Kendini yalnız hissediyor." },
  ];
  
  const microActions = { "YÜKSEK": "Liderlik yapabileceği sorumluluklar vererek gücünü okul yararına kullanmasını sağlayın.", "ORTA": "Bu hafta sadece iyi yaptığı tek bir yeteneği hakkında olumlu geri bildirim (takdir) verin.", "DÜŞÜK": "Onu 'başarılı olması gereken' ortamlardan bir anlık çekip, sadece 'olduğu gibi kabul edildiği' sohbet ortamına alın." };

  const totalStressRisk = scores.D4 + scores.D5 + scores.D7;
  let resilience = { label: "", color: "", bg: "", percent: 0, text: "" };
  if (totalStressRisk <= 4) { resilience = { label: "GÜÇLÜ (DİRENÇLİ)", color: "text-emerald-600", bg: "bg-emerald-500", percent: 85, text: "Stres, eleştiri ve depresif durumlara karşı duygusal kalkanı çok sağlam." }; } 
  else if (totalStressRisk <= 9) { resilience = { label: "KIRILGAN", color: "text-amber-500", bg: "bg-amber-400", percent: 50, text: "Zaman zaman dış eleştirilerden ve stres faktörlerinden yoğun şekilde etkileniyor." }; } 
  else { resilience = { label: "RİSKLİ", color: "text-red-600", bg: "bg-red-500", percent: 15, text: "Duygusal savunma mekanizması zayıflamış, yoğun psikosomatik ve depresif baskı altında." }; }

  const isIsolated = scores.D12 >= 1; const isThreatened = scores.D8 >= 2; const isDistrustful = scores.D3 >= 3;
  let socialProfile = [];
  if (!isIsolated && !isThreatened && !isDistrustful) { socialProfile.push({ text: "Sosyal İlişkilerde Güvende Hissediyor", icon: CheckCircle, color: "text-emerald-600", bg: "bg-emerald-50" }); } 
  else {
      if (isIsolated) socialProfile.push({ text: "Kendini Yalnız ve Anlaşılmaz Hissediyor", icon: AlertTriangle, color: "text-red-600", bg: "bg-red-50" });
      if (isThreatened) socialProfile.push({ text: "İkili İlişkilerde Tehdit Algısı Yüksek", icon: AlertCircle, color: "text-amber-600", bg: "bg-amber-50" });
      if (isDistrustful) socialProfile.push({ text: "İnsanlara Karşı Temkinli ve Güvensiz", icon: ShieldAlert, color: "text-indigo-600", bg: "bg-indigo-50" });
  }
  if (socialProfile.length === 0) socialProfile.push({ text: "Genel Sosyal Uyum Beklenen Düzeyde", icon: CheckCircle, color: "text-blue-600", bg: "bg-blue-50" });

  return (
    <div className="space-y-6 print:space-y-4 font-sans print:min-h-[260mm] flex flex-col">
      
      {/* HEADER */}
      <div className={`p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900 ${d1Result.level === 'DÜŞÜK' ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'}`}>
        <div>
          <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Rosenberg Benlik Saygısı Raporu</h2>
          <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">{meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}</span>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className="text-2xl print:text-xl font-black block leading-none">{scores.D1}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">D-1 Puanı</span>
        </div>
      </div>
      
      {/* 1. SATIR: D-1 BAROMETRE VE MİKRO AKSİYON */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-6 print:gap-4">
         <div className="bg-slate-50 p-6 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm">
           <div className="flex items-center mb-4 print:mb-2.5 border-b border-slate-200 pb-3 print:pb-2">
             <Activity className="h-6 w-6 print:h-4 print:w-4 text-slate-600 mr-3 print:mr-2"/>
             <div>
               <span className="text-sm print:text-[11px] font-black text-slate-800 uppercase tracking-widest block leading-none">D-1 Benlik Saygısı Barometresi</span>
               <span className="text-[10px] print:text-[8.5px] font-medium text-slate-500 uppercase tracking-wide mt-0.5 block">(0-1 Yüksek | 5-6 Düşük)</span>
             </div>
           </div>
           <div className="flex items-center justify-between mb-4 print:mb-2 mt-2 print:mt-1">
             <span className="text-sm print:text-[10px] font-black text-emerald-600">YÜKSEK</span>
             <div className="flex-1 px-4 print:px-3 flex items-center relative">
               <div className="h-3 print:h-2 flex-1 bg-emerald-400 rounded-l-full"></div>
               <div className="h-3 print:h-2 flex-1 bg-amber-400"></div>
               <div className="h-3 print:h-2 flex-1 bg-red-400 rounded-r-full"></div>
               <div className="absolute top-1/2 -translate-y-1/2 w-5 h-5 print:w-3.5 print:h-3.5 bg-white border-4 print:border-[3px] border-slate-900 rounded-full shadow-md" style={{ left: `calc(${(scores.D1 / 6) * 100}% - 10px)` }}></div>
             </div>
             <span className="text-sm print:text-[10px] font-black text-red-600">DÜŞÜK</span>
           </div>
           <div className={`mt-auto p-3 print:p-2.5 rounded-xl print:rounded-lg border flex items-start ${d1Result.bg.replace('bg-', 'bg-opacity-10 bg-')} ${d1Result.color.replace('text-', 'border-')}`}>
             <Heart className={`h-5 w-5 print:h-4 print:w-4 mr-3 print:mr-2 shrink-0 ${d1Result.color}`} />
             <p className={`text-xs print:text-[9.5px] font-bold leading-relaxed print:leading-snug ${d1Result.color}`}>Teşhis: {d1Result.desc}</p>
           </div>
         </div>
         
         <div className="bg-blue-50 p-6 print:p-4 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm relative overflow-hidden">
           <div className="flex items-center mb-4 print:mb-2.5 border-b border-blue-200 pb-3 print:pb-2 opacity-90 print:border-slate-200">
             <ShieldAlert className="h-6 w-6 print:h-4 print:w-4 mr-3 print:mr-2 text-blue-600"/>
             <span className="text-sm print:text-[11px] font-black uppercase tracking-widest text-blue-900">Öz Yeterlilik Aksiyonu</span>
           </div>
           <p className="text-sm print:text-[10px] text-slate-800 leading-relaxed print:leading-snug font-medium mb-2 text-justify">
             {microActions[d1Result.level]}
           </p>
         </div>
      </div>

      {/* 2. SATIR: DAYANIKLILIK VE SOSYAL PROFİL */}
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-6 print:gap-4">
         <div className="bg-white p-6 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-center print:border-slate-300">
             <div className="flex items-center mb-5 print:mb-3 border-b border-slate-100 pb-3 print:pb-2">
                 <Shield className="h-6 w-6 print:h-4 print:w-4 text-indigo-500 mr-3 print:mr-2"/>
                 <div>
                     <span className="text-sm print:text-[11px] font-black text-slate-800 uppercase tracking-widest block leading-none">Duygusal Dayanıklılık</span>
                     <span className="text-[10px] print:text-[8.5px] font-medium text-slate-400 uppercase tracking-wide mt-0.5 block">Kriz Yönetimi (Resilience)</span>
                 </div>
             </div>
             <div className="flex items-center justify-between mb-3 print:mb-2">
                 <span className={`text-base print:text-[12px] font-black ${resilience.color}`}>{resilience.label}</span>
                 <span className="text-sm print:text-[10px] font-bold text-slate-400">%{resilience.percent} Kapasite</span>
             </div>
             <div className="h-3 print:h-2 w-full bg-slate-100 rounded-full overflow-hidden mb-4 print:mb-2">
                 <div className={`h-full ${resilience.bg} transition-all duration-1000`} style={{ width: `${resilience.percent}%` }}></div>
             </div>
             <p className="text-xs print:text-[10px] text-slate-600 font-medium leading-relaxed print:leading-snug">
                 {resilience.text}
             </p>
         </div>

         <div className="bg-white p-6 print:p-4 rounded-2xl border border-slate-200 shadow-sm flex flex-col justify-start print:border-slate-300">
             <div className="flex items-center mb-4 print:mb-2.5 border-b border-slate-100 pb-3 print:pb-2">
                 <Users className="h-6 w-6 print:h-4 print:w-4 text-blue-500 mr-3 print:mr-2"/>
                 <div>
                     <span className="text-sm print:text-[11px] font-black text-slate-800 uppercase tracking-widest block leading-none">Sosyal İletişim Profili</span>
                     <span className="text-[10px] print:text-[8.5px] font-medium text-slate-400 uppercase tracking-wide mt-0.5 block">Dış Dünya İle Etkileşim</span>
                 </div>
             </div>
             <div className="space-y-3 print:space-y-2 flex-1 flex flex-col justify-center">
                 {socialProfile.map((item, idx) => (
                     <div key={idx} className={`flex items-center p-3 print:p-2.5 rounded-xl print:rounded-lg border ${item.bg.replace('bg-', 'border-').replace('50', '100')} ${item.bg}`}>
                         <item.icon className={`h-5 w-5 print:h-3.5 print:w-3.5 mr-3 print:mr-2 shrink-0 ${item.color}`} />
                         <span className={`text-xs print:text-[9.5px] font-bold ${item.color.replace('500', '700').replace('600', '800')}`}>{item.text}</span>
                     </div>
                 ))}
             </div>
         </div>
      </div>

      {/* 3. SATIR: 11 BOYUTLU KÜÇÜK KARTLAR (GRID) */}
      <div className="bg-slate-50 p-6 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none mt-2 print:mt-2 flex-1">
        <h3 className="font-bold text-slate-800 mb-5 print:mb-3 text-sm print:text-[11px] border-b pb-3 print:pb-2 uppercase tracking-wider">
           Çok Boyutlu Psikososyal Alt Ölçekler (D2 - D12)
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 print:grid-cols-3 gap-4 print:gap-2.5">
          {dimensions.map((dim, i) => { 
            const isRisk = dim.riskIfHigh ? dim.score > (dim.max / 2) : dim.score < (dim.max / 2); 
            return (
              <div key={i} className={`p-4 print:p-2.5 rounded-xl border shadow-sm print:shadow-none flex flex-col justify-between ${isRisk ? 'bg-red-50/50 border-red-200 print:border-slate-300' : 'bg-white border-slate-200'}`}>
                <div className="flex justify-between items-start mb-2 print:mb-1.5">
                  <h4 className="font-bold text-slate-800 text-xs print:text-[9.5px] leading-tight pr-2">{dim.title}</h4>
                  <div className={`text-[10px] print:text-[8.5px] font-black px-2 py-1 print:px-1.5 print:py-0.5 rounded-lg border ${isRisk ? 'bg-red-100 text-red-700 border-red-200' : 'bg-slate-100 text-slate-600 border-slate-200'}`}>{dim.score}/{dim.max}</div>
                </div>
                <p className={`text-[11px] print:text-[8.5px] font-medium leading-snug print:leading-tight mt-1 ${isRisk ? 'text-red-700' : 'text-slate-600'}`}>{dim.desc}</p>
              </div>
            ); 
          })}
        </div>
      </div>
    </div>
  );
};

// --- 2. KURUMSAL (TOPLU) HESAPLAMA MOTORU ---
export const aggregateRosenberg = (subs) => {
  const total = subs.length;
  if (total === 0) return null;

  let highEsteemCount = 0; // D1 <= 1
  let mediumEsteemCount = 0; // D1: 2-4
  let lowEsteemCount = 0; // D1 >= 5

  let totalD1 = 0;
  
  // Dayanıklılık (Resilience) Hesaplama (D4+D5+D7)
  let strongResilienceCount = 0;
  let fragileResilienceCount = 0;
  let riskResilienceCount = 0;

  // Sosyal Profil (D12, D8, D3)
  let isolatedCount = 0;
  let threatenedCount = 0;
  let distrustfulCount = 0;

  // Tüm 11 alt boyutun (D2-D12) ortalamaları için toplamlar
  const totalDims = { D2: 0, D3: 0, D4: 0, D5: 0, D6: 0, D7: 0, D8: 0, D9: 0, D10: 0, D11: 0, D12: 0 };
  const classMap = {};

  subs.forEach(s => {
    const className = s.studentClass || s.sinif || s.sınıf || s.class || s.grade || s.studentInfo?.sinif || "Tüm Sınıflar";
    if (!classMap[className]) {
      classMap[className] = { name: className, studentCount: 0, riskCount: 0 };
    }
    classMap[className].studentCount++;

    const scores = s.reportData?.scores || {};
    
    // 1. D1 Benlik Saygısı Kategorizasyonu
    const d1 = scores.D1 || 0;
    totalD1 += d1;
    if (d1 <= 1) highEsteemCount++;
    else if (d1 <= 4) mediumEsteemCount++;
    else {
        lowEsteemCount++;
        classMap[className].riskCount++;
    }

    // 2. Dayanıklılık (Resilience)
    const stressRisk = (scores.D4 || 0) + (scores.D5 || 0) + (scores.D7 || 0);
    if (stressRisk <= 4) strongResilienceCount++;
    else if (stressRisk <= 9) fragileResilienceCount++;
    else {
        riskResilienceCount++;
        classMap[className].riskCount += 0.5; // Dayanıklılığı düşük olan da sınıfa risk katar
    }

    // 3. Sosyal İzolasyon ve Tehdit
    if ((scores.D12 || 0) >= 1) isolatedCount++;
    if ((scores.D8 || 0) >= 2) threatenedCount++;
    if ((scores.D3 || 0) >= 3) distrustfulCount++;

    // 4. Alt Boyut Toplamları
    Object.keys(totalDims).forEach(key => {
        totalDims[key] += (scores[key] || 0);
    });
  });

  // Ortalamaları hesapla
  const avgD1 = total > 0 ? (totalD1 / total).toFixed(1) : 0;
  const avgDims = {};
  Object.keys(totalDims).forEach(key => {
      avgDims[key] = total > 0 ? (totalDims[key] / total).toFixed(1) : 0;
  });

  const topCategories = [
      { name: 'Sosyal İzolasyon / Yalnızlık', count: isolatedCount, percent: Math.round((isolatedCount / total) * 100) },
      { name: 'İlişkilerde Tehdit Algısı', count: threatenedCount, percent: Math.round((threatenedCount / total) * 100) },
      { name: 'İnsanlara Güvensizlik', count: distrustfulCount, percent: Math.round((distrustfulCount / total) * 100) }
  ].sort((a, b) => b.percent - a.percent);

  const classStats = Object.values(classMap).map(c => ({
    ...c,
    riskIntensity: c.studentCount > 0 ? Math.round((c.riskCount / c.studentCount) * 100) : 0
  })).sort((a, b) => b.riskIntensity - a.riskIntensity);

  return { total, highEsteemCount, mediumEsteemCount, lowEsteemCount, avgD1, strongResilienceCount, fragileResilienceCount, riskResilienceCount, avgDims, topCategories, classStats };
};


// --- 3. KURUMSAL RAPOR ARAYÜZÜ ---
export const RosenbergKurumsalUI = ({ title, subs, aiResult, onGenerateAI, aiLoading, handlePrint, downloading }) => {
  const data = aggregateRosenberg(subs);
  if (!data) return <div className="p-8 text-center text-slate-500">Bu gruba ait veri bulunamadı.</div>;

  const lowPercent = data.total > 0 ? Math.round((data.lowEsteemCount / data.total) * 100) : 0;
  const isRedAlarm = data.lowEsteemCount > 0;

  // Dayanıklılık (Resilience) Yüzdeleri
  const strongPercent = data.total > 0 ? Math.round((data.strongResilienceCount / data.total) * 100) : 0;
  const fragilePercent = data.total > 0 ? Math.round((data.fragileResilienceCount / data.total) * 100) : 0;
  const riskPercent = 100 - strongPercent - fragilePercent;

  // 11 Alt Boyut Sabitleri (Maksimum puanlar ve risk yönleri)
  const dimDefs = [
    { id: "D2", title: "Kendilik Sürekliliği", max: 5, riskIfHigh: true, score: data.avgDims.D2, desc: "Fikirlerin hızlı değişimi" },
    { id: "D3", title: "İnsanlara Güven", max: 5, riskIfHigh: true, score: data.avgDims.D3, desc: "Temkinli yaklaşım" },
    { id: "D4", title: "Eleştiriye Duyarlılık", max: 3, riskIfHigh: true, score: data.avgDims.D4, desc: "İncinme potansiyeli" },
    { id: "D5", title: "Depresif Duygulanım", max: 6, riskIfHigh: true, score: data.avgDims.D5, desc: "Karamsarlık düzeyi" },
    { id: "D6", title: "Hayalperestlik", max: 4, riskIfHigh: true, score: data.avgDims.D6, desc: "Gerçeklikten kopuş" },
    { id: "D7", title: "Psikosomatik Belirti", max: 10, riskIfHigh: true, score: data.avgDims.D7, desc: "Kaygının bedene vurması" },
    { id: "D8", title: "İlişkilerde Tehdit", max: 3, riskIfHigh: true, score: data.avgDims.D8, desc: "Sosyal ortam stresi" },
    { id: "D9", title: "Tartışmaya Katılım", max: 2, riskIfHigh: false, score: data.avgDims.D9, desc: "Görüş savunma gücü" },
    { id: "D10", title: "Ana-Baba İlgisi", max: 7, riskIfHigh: true, score: data.avgDims.D10, desc: "Aileden görülen ilgi" },
    { id: "D11", title: "Babayla İlişki", max: 6, riskIfHigh: false, score: data.avgDims.D11, desc: "Babayla iletişim" },
    { id: "D12", title: "Psişik İzolasyon", max: 2, riskIfHigh: true, score: data.avgDims.D12, desc: "Yalnızlık hissi" },
  ];

  return (
    <>
      <div className="flex justify-end mb-4 no-print px-2">
         <button onClick={() => handlePrint('rosenberg-kurumsal-area')} disabled={downloading} className="bg-blue-600 text-white px-5 py-2.5 rounded-xl font-bold flex items-center text-sm shadow-md hover:bg-blue-700 transition">
            {downloading ? <Loader2 className="animate-spin h-5 w-5 mr-2"/> : <Download className="h-5 w-5 mr-2"/>} Raporu Yazdır / PDF
         </button>
      </div>

      <div id="rosenberg-kurumsal-area" className="font-sans flex flex-col bg-white print:bg-white">
        
        {/* ========================================================= */}
        {/* SAYFA 1: DERGİ KAPAĞI - BENLİK VE DAYANIKLILIK VİTRİNİ    */}
        {/* ========================================================= */}
        <div className="flex flex-col gap-5 print:gap-3 mb-6 print:mb-0">
          
          {/* 1. ÜST BAŞLIK */}
          <div className={`p-5 print:p-3 rounded-2xl flex justify-between items-center shadow-sm print:shadow-none print:border-b-2 print:border-slate-900 ${isRedAlarm ? 'bg-red-900 text-white' : 'bg-slate-900 text-white'} shrink-0 avoid-break`}>
            <div className="flex items-center gap-5 print:gap-3">
              <div className={`h-14 w-14 print:h-10 print:w-10 rounded-xl flex items-center justify-center shadow-inner ${isRedAlarm ? 'bg-red-600' : 'bg-slate-700'}`}>
                <Activity className="h-7 w-7 print:h-5 print:w-5"/>
              </div>
              <div>
                <h2 className="text-2xl print:text-lg font-black leading-none mb-1">{title}</h2>
                <span className="text-xs print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
                   ROSENBERG BENLİK SAYGISI VE DAYANIKLILIK HARİTASI
                </span>
              </div>
            </div>
            <div className="bg-white/10 px-5 py-2.5 print:px-3 print:py-1.5 rounded-xl text-center print:border print:border-slate-300">
              <span className={`text-3xl print:text-xl font-black block leading-none ${isRedAlarm ? 'text-red-300' : 'text-slate-800'}`}>{data.total}</span>
              <span className="text-[10px] print:text-[8px] block opacity-70 uppercase font-bold mt-1">Katılımcı</span>
            </div>
          </div>

          {/* 2. 3'LÜ KPI KARTLARI */}
          <div className="grid grid-cols-1 md:grid-cols-3 print:grid-cols-3 gap-5 print:gap-3 shrink-0 avoid-break">
            <div className={`p-5 print:p-3 rounded-2xl border shadow-sm flex flex-col justify-center print:bg-white print:border-slate-300 ${isRedAlarm ? 'border-red-200' : 'border-slate-200'}`}>
              <div className="flex items-center mb-1.5">
                 <AlertTriangle className={`h-6 w-6 print:h-4 print:w-4 mr-2 ${isRedAlarm ? 'text-red-500' : 'text-emerald-500'}`}/>
                 <span className={`text-sm print:text-[10px] font-black uppercase tracking-widest ${isRedAlarm ? 'text-red-600' : 'text-emerald-600'}`}>Düşük Benlik / Risk Grubu</span>
              </div>
              <p className={`text-2xl print:text-lg font-black mt-1 ${isRedAlarm ? 'text-red-700' : 'text-emerald-700'}`}>
                 {data.lowEsteemCount} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci (%{lowPercent})</span>
              </p>
            </div>
            <div className="bg-emerald-50 p-5 print:p-3 rounded-2xl border border-emerald-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <ShieldCheck className="h-6 w-6 print:h-4 print:w-4 mr-2 text-emerald-600"/>
                 <span className="text-sm print:text-[10px] font-black text-emerald-600 uppercase tracking-widest">Yüksek / Sağlam Benlik</span>
              </div>
              <p className="text-2xl print:text-lg font-black text-emerald-900 mt-1">
                 {data.highEsteemCount} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">Öğrenci</span>
              </p>
            </div>
            <div className="bg-indigo-50 p-5 print:p-3 rounded-2xl border border-indigo-100 print:bg-white print:border-slate-300 shadow-sm flex flex-col justify-center">
              <div className="flex items-center mb-1.5">
                 <Target className="h-6 w-6 print:h-4 print:w-4 mr-2 text-indigo-600"/>
                 <span className="text-sm print:text-[10px] font-black text-indigo-600 uppercase tracking-widest">Ortalama D-1 Skoru</span>
              </div>
              <p className="text-2xl print:text-lg font-black text-indigo-900 mt-1">
                 {data.avgD1} <span className="text-xs print:text-[9px] font-medium opacity-70 text-slate-600 uppercase">/ 6.0 Puan</span>
              </p>
            </div>
          </div>

          {/* 3. MASONRY GRID (2 KARE + 2 YATAY KART) */}
          <div className="grid grid-cols-2 gap-5 print:gap-3 shrink-0 avoid-break mt-1 print:mt-0">
            
            {/* KART 1: KARE - EN RİSKLİ ŞUBELER RADARI */}
            <div className="col-span-1 bg-blue-50 p-5 print:p-3.5 rounded-2xl border border-blue-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-blue-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-blue-200 print:border-slate-200 pb-1.5">
                 <Users className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-blue-600"/> Kırılgan Şube Radarı
               </h3>
               <div className="space-y-2 print:space-y-1 mt-1">
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-blue-500 uppercase tracking-widest block mb-0.5">1. Öncelikli Grup</span>
                    <p className="text-sm print:text-[10px] font-black text-slate-800 leading-tight truncate">
                      {data.classStats[0] ? data.classStats[0].name : 'Belirsiz'}
                      {data.classStats[0] && <span className="text-[10px] print:text-[8px] font-bold text-red-600 ml-1">(%{data.classStats[0].riskIntensity} Kriz)</span>}
                    </p>
                  </div>
                  <div>
                    <span className="text-[10px] print:text-[8px] font-bold text-slate-500 uppercase tracking-widest block mb-0.5">2. Öncelikli Grup</span>
                    <p className="text-xs print:text-[9px] font-black text-slate-700 leading-tight truncate">
                      {data.classStats[1] ? data.classStats[1].name : 'Diğer Gruplar Normal'}
                      {data.classStats[1] && <span className="text-[10px] print:text-[8px] font-bold text-red-500 ml-1">(%{data.classStats[1].riskIntensity} Kriz)</span>}
                    </p>
                  </div>
               </div>
            </div>

            {/* KART 2: KARE - DUYGUSAL DAYANIKLILIK (RESILIENCE) BAROMETRESİ */}
            <div className="col-span-1 bg-purple-50 p-5 print:p-3.5 rounded-2xl border border-purple-100 print:bg-white print:border-slate-300 flex flex-col justify-center shadow-sm print:shadow-none print:min-h-[90px]">
               <h3 className="font-bold text-purple-900 mb-3 print:mb-2 flex items-center text-xs print:text-[10px] uppercase tracking-widest border-b border-purple-200 print:border-slate-200 pb-1.5">
                 <Shield className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-purple-600"/> Kurumsal Dayanıklılık
               </h3>
               
               <div className="flex items-center justify-between mb-1 mt-1 px-1">
                   <span className="text-[9px] print:text-[7.5px] font-bold text-emerald-600 text-center">GÜÇLÜ<br/>%{strongPercent}</span>
                   <span className="text-[9px] print:text-[7.5px] font-bold text-amber-600 text-center">KIRILGAN<br/>%{fragilePercent}</span>
                   <span className="text-[9px] print:text-[7.5px] font-bold text-rose-600 text-center">RİSKLİ<br/>%{riskPercent}</span>
               </div>
               <div className="h-3 print:h-2 w-full bg-slate-100 rounded-full flex overflow-hidden print:border print:border-slate-300">
                   <div className="h-full bg-emerald-500 print:bg-slate-400" style={{ width: `${strongPercent}%` }}></div>
                   <div className="h-full bg-amber-400 print:bg-slate-600" style={{ width: `${fragilePercent}%` }}></div>
                   <div className="h-full bg-rose-600 print:bg-slate-800" style={{ width: `${riskPercent}%` }}></div>
               </div>
               
               <p className="text-[10px] print:text-[8px] text-slate-700 leading-snug font-medium mt-2 text-justify line-clamp-2">
                 Okuldaki öğrencilerin strese, eleştiriye ve depresif durumlara karşı gösterdikleri direnç (Resilience) kapasitesidir.
               </p>
            </div>

            {/* KART 3: YATAY - SOSYAL İZOLASYON VE GÜVEN (BAR CHART) */}
            <div className="col-span-2 bg-slate-50 p-5 print:p-3.5 rounded-2xl border border-slate-200 print:bg-white print:border-slate-300 shadow-sm print:shadow-none">
               <div className="flex justify-between items-center border-b border-slate-200 print:border-slate-200 pb-2 mb-2">
                 <h3 className="font-bold text-slate-800 flex items-center text-xs print:text-[10px] uppercase tracking-widest">
                   <BarChart3 className="h-5 w-5 print:h-3.5 print:w-3.5 mr-2 text-slate-600"/> Kurumsal Sosyal Uyum ve Tehdit Algısı
                 </h3>
                 <span className="text-[10px] print:text-[8px] text-slate-500 italic">Genel Risk Yüzdesi</span>
               </div>
               
               <div className="space-y-3 print:space-y-2">
                  {data.topCategories.map((dim, idx) => (
                    <div key={idx}>
                      <div className="flex justify-between items-end mb-1 print:mb-0.5">
                        <span className="text-xs print:text-[9px] font-bold text-slate-700">{dim.name}</span>
                        <span className="text-xs print:text-[9px] font-black text-slate-900">%{dim.percent} <span className="text-[10px] print:text-[7.5px] text-slate-500 font-medium">({dim.count} Öğrenci)</span></span>
                      </div>
                      <div className="h-2 print:h-1.5 w-full bg-slate-200 print:bg-slate-100 rounded-full overflow-hidden print:border print:border-slate-200">
                        <div className="h-full rounded-full bg-indigo-500 print:bg-slate-500" style={{ width: `${dim.percent}%` }}></div>
                      </div>
                    </div>
                  ))}
               </div>
            </div>

          </div>

          {/* 4. 11 BOYUTLU KÜÇÜK KARTLAR (GRID) - 1. SAYFANIN ALTINI DOLDURUR */}
          <div className="bg-slate-50 p-6 print:p-4 rounded-2xl border border-slate-200 print:bg-white print:border-t-2 print:border-slate-900 print:rounded-none print:shadow-none mt-2 print:mt-1 flex-1 avoid-break">
            <h3 className="font-bold text-slate-800 mb-5 print:mb-3 text-sm print:text-[11px] border-b pb-3 print:pb-2 uppercase tracking-wider">
               Okulun Ortalama Psikososyal Alt Ölçek Puanları (D2 - D12)
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 print:grid-cols-3 gap-4 print:gap-2.5">
              {dimDefs.map((dim, i) => { 
                const isRisk = dim.riskIfHigh ? dim.score > (dim.max / 2) : dim.score < (dim.max / 2); 
                return (
                  <div key={i} className={`p-4 print:p-2.5 rounded-xl border shadow-sm print:shadow-none flex flex-col justify-between ${isRisk ? 'bg-red-50/50 border-red-200 print:border-slate-300' : 'bg-white border-slate-200'}`}>
                    <div className="flex justify-between items-start mb-2 print:mb-1.5">
                      <h4 className="font-bold text-slate-800 text-xs print:text-[9.5px] leading-tight pr-2">{dim.title}</h4>
                      <div className={`text-[10px] print:text-[8.5px] font-black px-2 py-1 print:px-1.5 print:py-0.5 rounded-lg border ${isRisk ? 'bg-red-100 text-red-700 border-red-200' : 'bg-slate-100 text-slate-600 border-slate-200'}`}>{dim.score}/{dim.max}</div>
                    </div>
                    <p className={`text-[11px] print:text-[8.5px] font-medium leading-snug print:leading-tight mt-1 ${isRisk ? 'text-red-700' : 'text-slate-600'}`}>{dim.desc}</p>
                  </div>
                ); 
              })}
            </div>
          </div>

        </div>
        {/* ==================== 1. SAYFA SONU ==================== */}

        <div className="hidden print:block" style={{ pageBreakBefore: 'always' }}></div>

        {/* ========================================================= */}
        {/* SAYFA 2: YAPAY ZEKA RAPORU VE İMZALAR                    */}
        {/* ========================================================= */}
        <div className="flex flex-col mt-4 print:mt-0">
          
          <div className="bg-purple-50 p-6 print:p-0 rounded-3xl print:rounded-none border border-purple-100 print:border-none shadow-sm print:shadow-none flex flex-col pt-2 print:pt-4">
            <div className="flex justify-between items-center mb-4 print:mb-3 border-b border-purple-200 print:border-slate-300 pb-3 print:pb-3 shrink-0">
              <h3 className="font-bold text-purple-900 flex items-center text-base print:hidden uppercase tracking-widest">
                <Sparkles className="h-5 w-5 mr-2 text-purple-600"/> Yapay Zeka Kurumsal Strateji Raporu
              </h3>
              <h3 className="hidden print:flex items-center font-bold text-slate-900 text-sm uppercase tracking-widest w-full">
                <Brain className="h-5 w-5 mr-2"/> Kurumsal Ruh Sağlığı ve Destek Planı
              </h3>
              <button onClick={() => onGenerateAI(title, data.topCategories)} disabled={aiLoading} className="px-5 py-2.5 bg-purple-600 text-white rounded-xl font-bold text-xs hover:bg-purple-700 transition shadow-sm print:hidden flex items-center">
                {aiLoading ? <Loader2 className="animate-spin h-4 w-4 mr-2"/> : <Brain className="h-4 w-4 mr-2"/>}
                {aiLoading ? "Analiz Ediliyor..." : "Raporu Oluştur"}
              </button>
            </div>
            {aiResult && (
            <div className="bg-white p-6 rounded-xl text-slate-800 border border-purple-100 print:border-0 print:p-0 print:text-black mt-4">
                <EditableAIBox text={aiResult} />
            </div>
        )}
          </div>

          <div className="hidden print:flex justify-between mt-10 pt-4 text-[10px] text-black px-12 shrink-0 border-t border-slate-300">
              <div className="text-center">
                  <p className="font-bold">Okul Psikolojik Danışmanı</p>
                  <p className="mt-16">İmza</p>
              </div>
              <div className="text-center">
                  <p className="font-bold">Okul Müdürü</p>
                  <p className="mt-16">İmza</p>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
};